/**
 * Подписи состояний папки — рантайм-значения к типу из
 * `mailbox-sync-contract.d.ts`.
 *
 * Отдельным файлом и `.ts`, как `checkpoint-labels.ts`: бэкенду подписи не
 * нужны, поэтому в его сборку файл не попадает и структуру `dist` не меняет.
 */

import type { FolderSyncStatus } from './mailbox-sync-contract.js';

export const FOLDER_SYNC_LABELS: Record<FolderSyncStatus, string> = {
  pending: 'Ожидает',
  syncing: 'Синхронизируется',
  synced: 'Синхронизирована',
  error: 'Ошибка',
};
